// extracted by mini-css-extract-plugin
export default {"content":"WireInstructionsListContent_content__6RQB-","expandedContent":"WireInstructionsListContent_expandedContent__EJxlb"};